export const INDUSTRY_OPTIONS = [
  'Civil engineering',
  'Consumer services',
  'Consumer electronics',
  'Glass, ceramics & concrete',
  'Government administration',
  'Machinery',
  'Mechanical or industrial engineering',
  'Media Production',
  'Logistics & supply chain',
  'Food & beverages',
  'Railroad manufacture',
  'Research',
  'Renewables & environment',
  'Automotive',
  'Electrical/electronic manufacturing',
  'Environmental services',
  'Entertainment',
  'Facilities services',
  'Furniture',
  'Chemicals',
  'Defense & space',
  'Food production',
  'Health, wellness & fitness',
  'Industrial Automation',
  'Internet',
  'Information technology & services',
  'Building materials',
  'Consumer goods',
  'Executive Offices',
  'Oil & energy',
  'Retail',
  'Construction',
  'Nanotechnology',
  'Packaging & containers',
  'Paper & forest products',
  'Pharmaceuticals',
  'Plastics',
  'Publishing',
  'Printing',
  'Telecommunications',
  'Textiles',
  'Mining & metals',
  'Medical devices',
  'Semiconductors',
  'Transportation/trucking/railroad',
  'Utilities',
  'Farming'
];

export const INDUSTRY_COLORS = {
  'Civil engineering': 'bg-gray-100 text-gray-700 border border-gray-200',
  'Consumer services': 'bg-cyan-100 text-cyan-700 border border-cyan-200',
  'Consumer electronics': 'bg-teal-100 text-teal-700 border border-teal-200',
  'Government administration': 'bg-gray-100 text-gray-700 border border-gray-200',
  'Glass, ceramics & concrete': 'bg-blue-100 text-blue-700 border border-blue-200',
  'Machinery': 'bg-blue-100 text-blue-700 border border-blue-200',
  'Mechanical or industrial engineering': 'bg-indigo-100 text-indigo-700 border border-indigo-200',
  'Media Production': 'bg-indigo-100 text-indigo-700 border border-indigo-200',
  'Logistics & supply chain': 'bg-indigo-100 text-indigo-700 border border-indigo-200',
  'Food & beverages': 'bg-teal-100 text-teal-700 border border-teal-200',
  'Railroad manufacture': 'bg-gray-100 text-gray-700 border border-gray-200',
  'Research': 'bg-indigo-100 text-indigo-700 border border-indigo-200',
  'Renewables & environment': 'bg-emerald-100 text-emerald-700 border border-emerald-200',
  'Automotive': 'bg-zinc-100 text-zinc-700 border border-zinc-200',
  'Electrical/electronic manufacturing': 'bg-yellow-100 text-yellow-700 border border-yellow-200',
  'Environmental services': 'bg-green-100 text-green-700 border border-green-200',
  'Facilities services': 'bg-green-100 text-green-700 border border-green-200',
  'Food production': 'bg-orange-100 text-orange-700 border border-orange-200',
  'Furniture': 'bg-orange-100 text-orange-700 border border-orange-200',
  'Health, wellness & fitness': 'bg-teal-100 text-teal-700 border border-teal-200',
  'Industrial Automation': 'bg-zinc-100 text-zinc-700 border border-zinc-200',
  'Internet': 'bg-orange-100 text-orange-700 border border-orange-200',
  'Information technology & services': 'bg-blue-100 text-blue-700 border border-blue-200',
  'Entertainment': 'bg-yellow-100 text-yellow-700 border border-yellow-200',
  'Chemicals': 'bg-red-100 text-red-700 border border-red-200',
  'Defense & space': 'bg-red-100 text-red-700 border border-red-200',
  'Building materials': 'bg-stone-100 text-stone-700 border border-stone-200',
  'Consumer goods': 'bg-purple-100 text-purple-700 border border-purple-200',
  'Executive Offices': 'bg-slate-100 text-slate-700 border border-slate-200',
  'Oil & energy': 'bg-amber-100 text-amber-700 border border-amber-200',
  'Retail': 'bg-purple-100 text-purple-700 border border-purple-200',
  'Construction': 'bg-orange-100 text-orange-700 border border-orange-200',
  'Nanotechnology': 'bg-orange-100 text-orange-700 border border-orange-200',
  'Packaging & containers': 'bg-orange-100 text-orange-700 border border-orange-200',
  'Paper & forest products': 'bg-orange-100 text-orange-700 border border-orange-200',
  'Pharmaceuticals': 'bg-rose-100 text-rose-700 border border-rose-200',
  'Plastics': 'bg-rose-100 text-rose-700 border border-rose-200',
  'Publishing': 'bg-rose-100 text-rose-700 border border-rose-200',
  'Printing': 'bg-gray-100 text-gray-700 border border-gray-200',
  'Telecommunications': 'bg-cyan-100 text-cyan-700 border border-cyan-200',
  'Textiles': 'bg-violet-100 text-violet-700 border border-violet-200',
  'Mining & metals': 'bg-yellow-100 text-yellow-700 border border-yellow-200',
  'Medical devices': 'bg-cyan-100 text-cyan-700 border border-cyan-200',
  'Semiconductors': 'bg-yellow-100 text-yellow-700 border border-yellow-200',
  'Transportation/trucking/railroad': 'bg-gray-100 text-gray-700 border border-gray-200',
  'Utilities': 'bg-gray-100 text-gray-700 border border-gray-200',
  'Farming': 'bg-green-100 text-green-700 border border-green-200',
};


/**
 * Get industry options as an array
 * @returns {Array<string>} Array of industry strings
 */
export const getIndustryOptions = () => {
  return [...INDUSTRY_OPTIONS].sort((a, b) => a.localeCompare(b));
};

/**
 * Get industry colors mapping
 * @returns {Object} Object mapping industry names to color classes
 */
export const getIndustryColors = () => {
  return { ...INDUSTRY_COLORS };
};

/**
 * Get color for a specific industry
 * @param {string} industry - The industry name
 * @returns {string} The color classes for the industry
 */
export const getIndustryColor = (industry) => {
  return INDUSTRY_COLORS[industry] || INDUSTRY_COLORS['Other'];
};

